/**
 * Dock aç/kapa kısayolu: ⌘J (mac) / Ctrl+J (diğerleri).
 * Sol sidebar'ın ⌘B'si ile aynı platform ayrımı (bkz. components/ui/sidebar).
 */
const isMac = (): boolean =>
  typeof navigator !== "undefined" &&
  /mac/i.test(navigator.platform || navigator.userAgent);

export const DOCK_SHORTCUT_LABEL = isMac() ? "⌘J" : "Ctrl+J";

/** Olay dock kısayoluysa true; çağıran preventDefault'u kendi yapar. */
export const isDockShortcut = (event: KeyboardEvent): boolean => {
  if (typeof event.key !== "string" || event.key.toLowerCase() !== "j") {
    return false;
  }
  if (event.altKey || event.shiftKey) return false;
  return isMac()
    ? event.metaKey && !event.ctrlKey
    : event.ctrlKey && !event.metaKey;
};
